function getBannerBottomPos(bannerElement: Element | null) {
    let pos = 0;
    if (bannerElement) {
        let shift = (bannerElement as HTMLElement).offsetHeight;
        if (shift > 0) {
            let bottom;
            if (typeof window.getComputedStyle === 'function') {
                bottom = parseInt(window.getComputedStyle(bannerElement)['bottom']);
            }
            if (typeof bottom === 'number' && !isNaN(bottom)) {
                shift += bottom + 2;
            } else {
                shift += 10;
            }
            pos = shift;
        }
    }
    return pos;
}

/**
 * Возвращает ссылку на DOM-элемент, представляющий баннер о применении кук.
 * Если баннер скрыт, возвращает `null`.
 *
 * @return
 *      Ссылка на DOM-элемент, представляющий баннер о применении кук, или `null`, если баннер не найден или скрыт.
 */
export function getVisibleCookieBannerElement(): HTMLElement | null {
    const cookieBanner = document.getElementById('cookieBanner');
    // Баннер может быть скрыт путем его размещения в невидимом элементе с нулевой высотой.
    // Поэтому проверяем высоту у родительского элемента.
    return (cookieBanner && cookieBanner.parentNode && (cookieBanner.parentNode as HTMLElement).offsetHeight > 0)
        ? cookieBanner
        : null;
}

/**
 * Возвращает позицию снизу для отображения над баннером о применении кук.
 *
 * @return
 *      Позицию снизу для отображения над баннером о применении кук
 *      или 0, если баннер не найден или скрыт.
 */
export function getBottomPosAboveCookieBanner() {
    return getBannerBottomPos(getVisibleCookieBannerElement());
}

/**
 * Возвращает позицию снизу для отображения над баннером о применении рекомендательных технологий.
 *
 * @return
 *      Позицию снизу для отображения над баннером о применении рекомендательных технологий
 *      или 0, если баннер не найден.
 */
export function getBottomPosAboveRtTermsBanner() {
    return getBannerBottomPos(document.querySelector('.rtterms-banner'));
}

/**
 * Возвращает позицию снизу для отображения над баннером, который выводится в нижней части экрана.
 * Это может быть баннер о применении кук или баннер о применении рекомендательных технологий.
 *
 * @return
 *      Позицию снизу для отображения над баннером или 0, если баннер не найден.
 */
export function getBottomPosAboveFooterBanner() {
    const pos = getBottomPosAboveRtTermsBanner();
    return pos > 0
        ? pos
        : getBottomPosAboveCookieBanner();
}
